<template>
	<div class="main-content-padding">
		<Panel :contentPaddingTop="12" class="extenTecord">
			<platformTab @change="platformTabClick" :showAll="false" :platformId="platformId"></platformTab>
			<div v-show="showPlatformContent">
				<el-radio-group v-model="tabName" @change="handleClick">
					<el-radio-button :label="item.name" v-for="item in shareTypeList" :key="item.name">{{ item.label }}</el-radio-button>
				</el-radio-group>
				<div class="statistics mb-20 mt-20" v-if="showStatistics">
					<div class="flex box">
						<div class="item ml-30" v-for="item in publicArr" :key="item.field">
							<p class="fz-24 yx-color-text-primary font-bold">{{ item.value || '0' }}</p>
							<p class="fz-12 yx-color-text-regular flex flex-align-center mt-8">
								<span>{{ item.label }}</span>
								<explain :content="item.helpDesc" v-if="item.helpDesc" placement="bottom"></explain>
							</p>
						</div>
					</div>
					<div class="desc yx-color-text-primary font-bold mt-30">查看记录</div>
				</div>
				<div class="search" v-else>
					<search ref="search" @onSubmit="onSubmit" :tabName="tabName"></search>
				</div>
			</div>
		</Panel>
		<Panel v-show="showPlatformContent">
			<multi-table ref="multiTable" :columns="columns" @gePartnerList="getList" :list="list" :total="total">
				<empty :isSearch="isSearch" ref="empty" slot="empty"></empty>
			</multi-table>
		</Panel>
		<qr-code-dialog ref="qrCodeDialog" />
		<look-record ref="lookRecord" :platformId="platformId" />
		<add-contact ref="addContact" :platformId="platformId" @refresh="getPromotionList"></add-contact>
	</div>
</template>
<script>
import search from './components/search.vue';
import qrCodeDialog from './components/qrCodeDialog';
import lookRecord from './components/lookRecord';
import { public_columns, private_columns, dr_shop_columns, tz_shop_columns } from './columns';
import { promotionList, promotionPublicList, productList, productDetail } from '@/api/extenTecord';
import { mapGetters } from 'vuex';
import addContact from '@/views/common/dialog/addContact.vue';
import { platformMixin } from '@rd/rd-ui';
import Explain from '@/components/common/explain';
import empty from '@/views/common/empty/index.vue';
export default {
	name: 'extenTecord',
	components: {
		search,
		qrCodeDialog,
		lookRecord,
		addContact,
		Explain,
		empty,
	},
	mixins: [platformMixin],
	data() {
		return {
			list: [],
			pageInfo: {
				page_index: 1,
				page_size: 10,
				item_total: 0,
			},
			tabName: '1',
			total: '',
			publicArr: [
				{ label: '查看人数', value: '0', field: 'view_count' },
				{ label: '选品人数', value: '0', field: 'selection_count' },
				{ label: '授权达人数', value: '0', field: 'auth_count', helpDesc: '商品库公开选品渠道做抖快账号授权的达人数' },
			],
			isSearch: false,
		};
	},
	computed: {
		...mapGetters(['defaultPlatform', 'isAllDataView']),
		isShopType() {
			return this.tabName === '2';
		},
		shareTypeList() {
			const shopType = this.$auth.hasPermi('system:goods:promote') ? [{ label: '选品中心分享', name: '2' }] : [];
			return [{ label: '公开分享', name: '1' }, ...shopType];
		},
		columns() {
			const { tabName } = this;
			return tabName === '1' ? public_columns : tabName === '0' ? private_columns : this.isAllDataView ? tz_shop_columns : dr_shop_columns;
		},
		showStatistics() {
			return this.isShopType && !this.isAllDataView;
		},
	},
	mounted() {
		this.pageInfo.platform_id = this.platformId;
		this.getPromotionList();
	},
	methods: {
		//获取列表
		async getPromotionList(isSearch) {
			this.isSearch = Boolean(isSearch);
			this.list = [];
			const apis = [promotionList, promotionPublicList];
			const _api = this.isShopType ? (this.isAllDataView ? productList : productDetail) : apis[this.tabName];
			const { code, data } = await _api(this.pageInfo);
			let { list = [], page = {}, share_view: { list: shareViewList = [], page: shareViewPage = {} } = {}, share_info = {} } = data;
			if (this.isShopType && !this.isAllDataView) {
				list = shareViewList;
				page = shareViewPage;
			}
			if (code == 0) {
				this.list = list.map(item => ({
					...item,
					operations: this.getButtons(item),
				}));
				this.total = `${page.item_total}`;
				this.isShopType && (this.publicArr = this.publicArr.map(({ field, ...rest }) => ({ ...rest, value: share_info[field], field })));
			}
		},
		platformTabClick(val) {
			this.platformId = val;
			if (!this.showPlatformContent) return;
			this.tabName = '1';
			this.handleClick();
		},
		handleClick() {
			this.pageInfo = {
				page_index: 1,
				page_size: 10,
				item_total: 0,
				platform_id: this.platformId,
			};
			this.$refs?.search?.clearData();
			this.getPromotionList();
		},
		getButtons({ is_contact }) {
			const isContact = +is_contact === 0;
			const contact = {
				label: isContact ? '添加联系人' : '查看联系人',
				type: 'text',
				classtype: 2,
				isShow: isContact ? this.$auth.hasPermi('system:talnetContacts:add-edit') : this.$auth.hasPermi('system:talnetContacts:query'),
				click: ({ open_id, contact_id }) => {
					if (isContact) {
						this.$refs.addContact.show(open_id, true);
						return;
					}
					const routeLink = this.$router.resolve({
						path: '/talentCRM/contacts',
						query: { contact_id },
					});
					window.open(routeLink.href, '_blank');
				},
			};
			const viewGoodsList = {
				label: '查看商品列表',
				type: 'text',
				classtype: 2,
				isShow: !this.isShopType && this.$auth.hasPermi('system:extenTecordDetails-query'),
				click: ({ id: share_id, share_type }) =>
					this.$router.push({
						path: '/shopManage/extenTecord/details/list',
						query: { share_id, share_type, platformId: this.platformId },
					}),
			};
			const viewQrcode = {
				label: '查看二维码',
				type: 'text',
				classtype: 2,
				isShow: true,
				click: ({ id }) => this.$refs.qrCodeDialog.show(id),
			};
			const viewGoodsViewRecord = {
				label: '商品查看记录',
				type: 'text',
				classtype: 2,
				isShow: !!+this.tabName,
				click: row => this.$refs.lookRecord.show(row),
			};
			const arr = this.showStatistics ? [contact] : [viewGoodsList, viewQrcode, viewGoodsViewRecord];
			let filterArr = arr.filter(item => item.isShow);
			return filterArr;
		},
		onSubmit(val) {
			this.pageInfo = val;
			this.pageInfo.page_index = 1;
			this.pageInfo.page_size = 10;
			this.pageInfo.platform_id = this.platformId;
			this.getPromotionList(1);
		},
		getList(obj) {
			const { page_index, page_size } = obj;
			this.pageInfo.page_index = page_index;
			this.pageInfo.page_size = page_size;
			this.getPromotionList();
		},
	},
};
</script>
<style scss="less" scoped>
.box {
	display: grid;
	grid-template-columns: repeat(4, 20%);
}

.desc {
	padding-top: 20px;
	margin-left: 12px;
	border-top: 1px solid #eee;
}
</style>
